import React from "react";
import "../Styles/Recruiters.css"; // Ensure this path is correct

// Import company logos
import company1 from "../Assets/Company1.png";
import company2 from "../Assets/Company2.png";
import company3 from "../Assets/Company3.png";
import company4 from "../Assets/Company4.png";
import company5 from "../Assets/Company5.png";
import company6 from "../Assets/Company6.png";
import company7 from "../Assets/Company7.png";
import company8 from "../Assets/Company8.png";



const recruiters = [company1, company2, company3, company4, company5, company6, company7,company8];

const Recruiters = () => {
  return (
    <section id="our-recruiters">
      <h2 className="section-title">Our Clients</h2>
      <div className="recruiters-slider">
        <div className="slider-track">
          {recruiters.concat(recruiters).map((logo, index) => (
            <div className="recruiter" key={index}>
              <img src={logo} alt={`Recruiter ${index + 1}`} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Recruiters;
